/**
 * Labstep
 *
 * @module grid/NewIndex/coldefs/experiment-workflow/linked-experiments
 * @desc Column Definition for experiment workflow linked experiments
 */

import type {
  EditableCallbackParams,
  ValueGetterParams,
} from 'ag-grid-community';
import { EntityLink } from 'labstep-web/components/Entity/Link';
import type { CellRendererParams } from 'labstep-web/core/DataGrid/types';
import type { Entity } from 'labstep-web/models/entity.model';
import type { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';

export const colDefExperimentWorkflowLinkedExperiments = {
  colId: 'linked_experiments',
  headerName: 'Linked Experiments',
  headerComponentParams: {
    icon: 'linkify',
    postFilterSettings: {
      field: 'linked_experiments',
      disableSort: true,
    },
  },
  editable: (params: EditableCallbackParams) => false,
  autoHeight: true,
  valueGetter: (params: ValueGetterParams): string | null => {
    const experiment_workflows =
      params.data?.linked_experiment_preview || [];
    return (
      experiment_workflows
        .map((workflow: ExperimentWorkflow) => workflow.name)
        .join(',') || null
    );
  },
  valueGetterExport: (params: ValueGetterParams) => {
    const experiment_workflows =
      params.node?.data?.linked_experiment_preview || [];
    return (
      experiment_workflows
        .map((workflow: ExperimentWorkflow) => workflow.name)
        .join(',') || ''
    );
  },
  cellRenderer: (params: CellRendererParams<Entity>) => {
    const experiment_workflows =
      params.node?.data?.linked_experiment_preview || [];
    return experiment_workflows.map((ew: ExperimentWorkflow) => (
      <EntityLink key={ew.id} entity={ew} showIcon />
    ));
  },
};
